import { render } from "./GoalManagement.vue?vue&type=template&id=3c4f36fc"
import script from "./GoalManagement.vue?vue&type=script&lang=js"
export * from "./GoalManagement.vue?vue&type=script&lang=js"

import "./GoalManagement.vue?vue&type=style&index=0&id=3c4f36fc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__